import { useState, useCallback, useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom"; // Import useSearchParams
import { CallApiGetUserHistories } from "../../../Api/Enforcement";
import {
  handleGetProfile,
  handleGetUserPass,
} from "../../../Share/Func/Storage";
import { SwalError } from "../../../Share/Swal";
import clsx from "clsx";
import Styles from "./index.module.scss";
import MenuVTC from "../../../Share/Component/MenuVtc";
import { formatNumber, formatDate } from "../../../Utils";
import { ONE_MILLION_UNIT } from "../../../Hooks/useClientProfile";
import { ClientTransactionTable } from "../../../Components/Molecules/ClientTransactionTable";
import { useNavigate } from "react-router-dom";
import { login } from "../../../Api/SubUrl";
import { MdOutlineArrowBackIosNew } from "react-icons/md";

function Transaction() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");

  const initialSelectedTable =
    type === "with_ref_rate"
      ? "ListWithRefRate"
      : type === "without_ref_rate"
      ? "ListWithoutRefRate"
      : "ListWithoutRefRate";

  const [transaction, setTransaction] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedTable, setSelectedTable] = useState(initialSelectedTable);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const voucherHistoryColumns = useMemo(
    () => [
      {
        header: "Loại",
        key: "VoucherCode",
        render: (row) => (row.VoucherCode ? "KM" : "Thường"),
      },
      { header: "KNB", key: "nExtPoint1" },
      { header: "KNB Khóa", key: "nExtPoint2" },
      {
        header: "Ngày thêm",
        key: "Create_Date",
        render: (row) => formatDate(row.Create_Date),
      },
      // { header: "Mã KM", key: "VoucherCode" },
      // {
      //   header: "Mức KM 1",
      //   key: "limit1",
      //   render: (row) =>
      //     row.limit1 ? formatNumber(row.limit1 * ONE_MILLION_UNIT) : "",
      // },
      // { header: "Tỉ lệ KM 1", key: "ex_rate1" },
      // {
      //   header: "Mức KM 2",
      //   key: "limit2",
      //   render: (row) =>
      //     row.limit2 ? formatNumber(row.limit2 * ONE_MILLION_UNIT) : "",
      // },
      // { header: "Tỉ lệ KM 2", key: "ex_rate2" },
    ],
    []
  );

  const introducedHistoryColumns = useMemo(
    () => [
      {
        header: "Người thêm",
        key: "UserCreate",
      },
      { header: "KNB thưởng", key: "nExtPoint1" },
      { header: "KNB Khóa thưởng", key: "nExtPoint2" },
      {
        header: "Ngày",
        key: "Create_Date",
        render: (row) => formatDate(row.Create_Date),
      },
    ],
    []
  );

  const handleCallApiTransaction = useCallback((page, fromDate, toDate) => {
    const user = handleGetProfile();
    if (user) {
      const param = {
        SignInModel: {
          UserName: user.Name,
          Password: handleGetUserPass(),
        },
        Page: page,
        PageSize: 10,
        DateFrom: fromDate ? fromDate : null,
        DateTo: toDate ? toDate : null,
      };
      CallApiGetUserHistories(param, (res) => {
        if (
          res &&
          res.ListWithRefRate &&
          res.ListWithoutRefRate &&
          typeof res.TotalBonus === "number"
        ) {
          setTransaction(res);
        } else {
          SwalError("Thử tải lại trang!\n Hoặc liên hệ fanpage để được hỗ trợ");
        }
      });
    }
  }, []);

  useEffect(() => {
    const user = handleGetProfile();
    if (!user) {
      navigate(login);
      return;
    }
    handleCallApiTransaction(currentPage, dateFrom, dateTo);
  }, [
    selectedTable,
    dateFrom,
    dateTo,
    currentPage,
    handleCallApiTransaction,
    navigate,
  ]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleCallApiTransaction(page, dateFrom, dateTo);
  };

  const handleTableChange = (e) => {
    setSelectedTable(e.target.value);
    setCurrentPage(0);
  };

  const handleDateFilter = () => {
    if (!dateFrom || !dateTo) return;
    setCurrentPage(0);
    handleCallApiTransaction(0, dateFrom, dateTo);
  };

  const handleBackToLogin = () => {
    navigate(login);
  };
  const renderPagination = () => {
    if (!transaction) return null;
    return (
      <div className={clsx(Styles.paginationWrapper)}>
        <button
          onClick={handleBackToLogin}
          className={clsx(Styles.paginationButton, Styles.homeButton)}
        >
          <MdOutlineArrowBackIosNew className={clsx(Styles.icon)} />
          Quay lại
        </button>
        <div className={clsx(Styles.pagination)}>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 0}
            className={clsx(Styles.paginationButton, Styles.paginationAction)}
          >
            Trước
          </button>
          {[...Array(transaction[selectedTable].TotalPagesCount)].map(
            (_, index) => (
              <button
                key={index}
                onClick={() => handlePageChange(index)}
                className={clsx(
                  Styles.paginationButton,
                  Styles.paginationPage,
                  currentPage === index && Styles.activePage
                )}
              >
                {index + 1}
              </button>
            )
          )}
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={
              currentPage === transaction[selectedTable].TotalPagesCount - 1
            }
            className={clsx(Styles.paginationButton, Styles.paginationAction)}
          >
            Sau
          </button>
        </div>
      </div>
    );
  };

  return (
    <div style={{ backgroundColor: "#000" }}>
      <div className={clsx(Styles.wrapper)}>
        <div className={clsx(Styles.wrapperInner)}>
          <div className={clsx(Styles.contentMain)}>
            <div className={clsx(Styles.detailContent)}>
              {transaction ? (
                <>
                  <div className={clsx(Styles.head)}>
                    <h3 style={{ textAlign: "center" }}>Lịch sử giao dịch</h3>
                  </div>
                  <div className={clsx(Styles.filters)}>
                    <div className={clsx(Styles.filterGroup)}>
                      <div className={clsx(Styles.inputGroup)}>
                        <input
                          type="date"
                          value={dateFrom}
                          onChange={(e) => setDateFrom(e.target.value)}
                          className={clsx(Styles.dateInput)}
                        />
                        <label>~</label>
                        <input
                          type="date"
                          value={dateTo}
                          onChange={(e) => setDateTo(e.target.value)}
                          className={clsx(Styles.dateInput)}
                        />
                      </div>
                      <button
                        onClick={handleDateFilter}
                        className={clsx(Styles.filterButton)}
                      >
                        Cập nhật
                      </button>
                    </div>

                    {/* <div className={clsx(Styles.filterTable)}>
                      <select
                        value={selectedTable}
                        onChange={handleTableChange}
                        className={clsx(Styles.select)}
                      >
                        <option value="ListWithoutRefRate">Lịch sử thêm</option>
                        <option value="ListWithRefRate">
                          Lịch sử giới thiệu
                        </option>
                      </select>
                    </div> */}
                  </div>
                  <div className={clsx(Styles.body)}>
                    <ClientTransactionTable
                      columns={
                        selectedTable === "ListWithoutRefRate"
                          ? voucherHistoryColumns
                          : introducedHistoryColumns
                      }
                      data={transaction[selectedTable].Items}
                      total={transaction[selectedTable].TotalItemsCount}
                    />
                    {renderPagination()}
                  </div>
                </>
              ) : (
                <>
                  <div className={clsx(Styles.head)}>
                    <h3 style={{ textAlign: "center" }}>{""}</h3>
                  </div>
                  <div className={clsx(Styles.body)}></div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <MenuVTC /> */}
    </div>
  );
}

export default Transaction;
